import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=26559ffc&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=26559ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26559ffc",
  null
  
)

export default component.exports